export default "__VITE_ASSET__97f51d78__"